import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "h4 title fw-normal mb-72 text-primary" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "form mb-48" }
const _hoisted_6 = { class: "row gx-32" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "row gx-32" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "form-actions text-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user-add-alt fw-bold me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_treeselect = _resolveComponent("treeselect")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('Añadir')) + " ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('nueva categoría')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_form_group_input_text, {
              label: _ctx.$t('Nombre'),
              value: _ctx.key,
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.name,
              autocomplete: "off",
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.key = $event))
            }, null, 8, ["label", "value", "yup-errors-variable"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_form_group_select, {
              label: _ctx.$t('Subcategoría de'),
              "yup-errors-variable": _ctx.errors.categories,
              class: "mb-0"
            }, null, 8, ["label", "yup-errors-variable"]),
            _createVNode(_component_treeselect, {
              label: _ctx.$t('Categorías'),
              modelValue: _ctx.typeSelected,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeSelected) = $event)),
              multiple: false,
              options: _ctx.categories,
              "disable-branch-nodes": true,
              placeholder: _ctx.$t('Selecciona el tipo de categoría')
            }, null, 8, ["label", "modelValue", "options", "placeholder"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_v_button, {
          variant: "link-secondary",
          class: "me-24",
          "aria-label": _ctx.$t('Cancelar'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
          ]),
          _: 1
        }, 8, ["aria-label"]),
        _createVNode(_component_v_button, {
          variant: "secondary",
          class: "btn-icon",
          "aria-label": _ctx.$t('Añadir'),
          disabled: !_ctx.meta.valid || _ctx.accepted,
          onClick: _ctx.createCategory,
          "is-loading": _ctx.accepted
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir')), 1)
          ]),
          _: 1
        }, 8, ["aria-label", "disabled", "onClick", "is-loading"])
      ])
    ])
  ], 64))
}